import { connect } from 'react-redux';
import type { State } from 'state';
import {
    getCanAdministerProject,
    getIsProjectSimplified,
    getPortalRequestTypes,
    getProjectKey,
} from 'state/selectors/portal';
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import { UI_EVENT_TYPE } from '@atlassian/analytics-web-react';

import type { InjectedProps } from '@atlassian/help-center-common-component/with-path-params';
import { withPathParams } from '@atlassian/help-center-common-component/with-path-params';
import { open } from '@atlassian/help-center-common-util/location';
import { getMeta } from '@atlassian/help-center-common-util/meta';
import { toNumber } from '@atlassian/help-center-common-util/number';
import { getNextgenSettingsRequestTypeUrl } from '@atlassian/help-center-common-util/url/url';
import RequestTypeSpotlightComponent from './request-type-spotlight';

const mapStateToProps = (state: State, props: InjectedProps) => {
    const portalId = toNumber(props.portalId);
    const portalRequestTypes = getPortalRequestTypes(state, portalId);
    const requestTypeId = portalRequestTypes.length > 0 ? portalRequestTypes[0].id : '';
    const projectKey = getProjectKey(state, portalId);
    const isNextGen = getIsProjectSimplified(state, portalId);
    const nextGenUrl = `${getNextgenSettingsRequestTypeUrl(projectKey || '', requestTypeId)}#showRequestTypesSpotlight`;
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const requestTypeConfigUrl = isNextGen ? nextGenUrl : `/servicedesk/admin/${projectKey}/request-types`;

    return {
        onEdit: () => open(requestTypeConfigUrl, '_blank'),
        isAdmin: getCanAdministerProject(state, portalId),
        cloudId: getMeta('tenant-id') || '',
    };
};

export default withPathParams(
    connect(mapStateToProps)(
        withAnalyticsContext({ componentName: 'RequestTypeSpotlight' })(
            withAnalyticsEvents({
                onEdit: createAndFireEvent()({
                    action: 'clicked',
                    analyticsType: UI_EVENT_TYPE,
                    actionSubjectId: 'jsdRequestTypeOnboardingEdit',
                }),
                onDismiss: createAndFireEvent()({
                    action: 'clicked',
                    analyticsType: UI_EVENT_TYPE,
                    actionSubjectId: 'jsdRequestTypeOnboardingDismiss',
                }),
            })(RequestTypeSpotlightComponent)
        )
    )
);
